import { createSlice } from '@reduxjs/toolkit';
import { initializeNotificationAsync } from './notificationsThunks';
const initialState = {
    badgeCount: 0,
    bootstrap: null
};
export const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        setBadgeCount(state, action) {
            state.badgeCount = Math.max(0, Number(action.payload) || 0);
        },
        setBootstrap(state, action) {
            state.bootstrap = action.payload ?? null;
        },
        resetBadgeCount(state) {
            state.badgeCount = 0;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(initializeNotificationAsync.fulfilled, (state, action) => {
            state.bootstrap = action.payload ?? null;
            state.badgeCount = Math.max(0, Number(action.payload?.unreadCount) || 0);
        });
    }
});
export const { setBadgeCount, resetBadgeCount, setBootstrap } = notificationsSlice.actions;
export default notificationsSlice.reducer;
